import { useRef, useState, useEffect, useMemo } from "react";
import { Navbar, Nav, Container, Button, Offcanvas } from "react-bootstrap";
import { Book, BoxArrowRight, MoonStars, People, Person, Search } from "react-bootstrap-icons";
import { BrowserRouter, Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import { useSession, SessionProvider } from "./authentication";
import { TitleProvider, useTitle } from "./context";
import { LoginPage } from "./loginPage";
import { SpellsPage } from "./spellsPage";
import { SpellPage } from "./spellPage";
import { ClassesPage } from "./classesPage";
import { ClassPage } from "./classPage";
import { SchoolsPage } from "./schoolsPage";
import { SchoolPage } from "./schoolPage";
import { SearchPage } from "./searchPage";
import { ProfilePage } from "./profilePage";

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

function MainPage() {
    const { logout, loading } = useSession();
    const { title } = useTitle();
    const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
    const [navbarHeight, setNavbarHeight] = useState();
    const location = useLocation();
    const navbarRef = useRef(null);
    
    useEffect(() => {
        const height = navbarRef.current?.getBoundingClientRect()?.height;
        setNavbarHeight(height ?? 70);
    }, [navbarRef.current]);

    return (
        <Container fluid className="m-0 p-0" style={{overflowY: "hidden"}}>
            <Navbar
            ref={navbarRef}
            bg="primary"
            variant="dark"
            expand={false}
            fixed="top">
                <Container fluid>
                    <Navbar.Toggle aria-controls="offcanvasNav" onClick={() => setShowHamburgerMenu(true)}/>

                    <Navbar.Brand className="mx-auto position-absolute start-50 translate-middle-x fw-semibold">{title}</Navbar.Brand>

                    <Navbar.Offcanvas
                    id="offcanvasNav"
                    placement="start"
                    show={showHamburgerMenu}
                    onHide={() => setShowHamburgerMenu(false)}
                    restoreFocus={false}
                    style={{ "--bs-offcanvas-width": "200px" }}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Spell Book</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="flex-column">
                                <Nav.Link as={NavLink} to="/spells" onClick={() => setShowHamburgerMenu(false)}>
                                    <Book className="me-2"/>
                                    Incantesimi
                                </Nav.Link>
                                <Nav.Link as={NavLink} to="/classes" onClick={() => setShowHamburgerMenu(false)}>
                                    <People className="me-2"/>
                                    Classi
                                </Nav.Link>
                                <Nav.Link as={NavLink} to="/schools" onClick={() => setShowHamburgerMenu(false)}>
                                    <MoonStars className="me-2"/>
                                    Scuole
                                </Nav.Link>
                                <Nav.Link as={NavLink} to="/search" onClick={() => setShowHamburgerMenu(false)}>
                                    <Search className="me-2"/>
                                    Ricerca
                                </Nav.Link>
                                
                                <div className="border-top mt-2 mb-1"></div>
                                
                                <Nav.Link as={NavLink} className="link-secondary" to="/profile" onClick={() => setShowHamburgerMenu(false)}>
                                    <Person className="me-2"/>
                                    Profilo
                                </Nav.Link>
                                <Nav.Link as={NavLink} className="link-danger" onClick={() => { logout(); setShowHamburgerMenu(false); }}>
                                    <BoxArrowRight className="me-2"/>
                                    Logout
                                </Nav.Link>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            <Routes>
                <Route path="/spells" element={<SpellsPage navbarHeight={navbarHeight}/>}/>
                <Route path="/spells/:spellId" element={<SpellPage navbarHeight={navbarHeight}/>}/>
                <Route path="/classes" element={<ClassesPage navbarHeight={navbarHeight}/>}/>
                <Route path="/classes/:classId" element={<ClassPage navbarHeight={navbarHeight}/>}/>
                <Route path="/schools" element={<SchoolsPage navbarHeight={navbarHeight}/>}/>
                <Route path="/schools/:schoolId" element={<SchoolPage navbarHeight={navbarHeight}/>}/>
                <Route path="/search" element={<SearchPage navbarHeight={navbarHeight}/>}/>
                <Route path="/profile" element={<ProfilePage navbarHeight={navbarHeight}/>}/>
                <Route path="*" element={<Navigate to="/spells" replace/>}/>
            </Routes>
        </Container>
    );
}

function AuthGate() {
    const { isAuthenticated } = useSession();
    return isAuthenticated ? (<TitleProvider><MainPage/></TitleProvider>) : <LoginPage/>;
}

function MainRouter() {
    return (
        <BrowserRouter>
            <AuthGate/>
        </BrowserRouter>
    )
}

export default function App() {
    return (
        <div className="min-h-screen bg-white">
            <SessionProvider>
                <MainRouter />
            </SessionProvider>
        </div>
    );
}
